import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import useWebSocket, { ReadyState } from 'react-use-websocket';

// EPortal 2.0
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShield } from "@fortawesome/free-solid-svg-icons";
import WhatWeDo from "./signin-components/what-we-do";
import WhomWeServe from "./signin-components/whom-we-serve";
import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { useDispatch } from "react-redux";
import { login } from "../redux/login/action";
import useLocales from "../hooks/useLocales";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { loginWithSAML } from "../api";
import { useLocation } from "react-router-dom";
const schema = yup.object().shape({
  email: yup
    .string()
    .email("Please enter a valid email")
    .required("Email is required"),
  password: yup.string().required().min(8),
});

const Logins = (props) => {
  /* eslint-disable */
  const dispatch = useDispatch();
  // const WS_URL = 'ws://localhost:8000';
  //socket connection start

  // const { lastJsonMessage } = useWebSocket(
  //   WS_URL, {
  //   share: false,
  //   shouldReconnect: () => true,
  // },
  // )
  // socket Connection End
  const { t } = useLocales();
  const [togglePassword, setTogglePassword] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [captchaState, setCaptchaState] = useState("");
  let captchaRef = useRef(null);

  const [captcha, setCaptcha] = useState(false);
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dynamicCaptcha, setDynamicCaptcha] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [totalPolicy, setTotalPolicy] = useState("syncing");
  const [isEAIUser, setIsEAIUser] = useState(false);
 const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const formDataRef = useRef(null);

  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    if (location.state?.showPasswordExpiredModal) {
      setShowPasswordModal(true);
      formDataRef.current = location.state.expiredUserData;

      // Clear state so modal doesn't reopen on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    generateDynamicCaptcha();

    if (localStorage.getItem("isRememberMe") == "true") {
      navigate("/rememberMe");
    }
    if (localStorage.getItem("token") != null) {
      navigate("/user/role");
    }
    if (localStorage.getItem("sessionErrorMessage") != null) {
      // toast.error(localStorage.getItem("sessionErrorMessage") );
      localStorage.clear("sessionErrorMessage");
    }
  }, []);
  // useEffect(() => {
  //   setTotalPolicy(lastJsonMessage?.result?.totalPolicy)
  // }, [lastJsonMessage])

  const validateRemember = () => {
    setRemember(!remember);
  };

  // const { register, handleSubmit, errors } = useForm();
  const {
    register,
    handleSubmit,
    errors,
    reset,
    watch,
    setError,
    clearErrors,
  } = useForm({
    resolver: yupResolver(schema),
  });

  // const email = watch('email');
  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "email") {
      // setIsEAIUser(value.includes("@europ-assistance"));
    }

    schema
      .validateAt(name, { [name]: value })
      .then(() => {
        setError(name, "");
      })
      .catch((error) => {
        setError(name, {
          type: "manual",
          message: error.message,
        });
      });
  };

  const generateDynamicCaptcha = () => {
    const newCaptcha = Math.random().toString(36).substring(2, 7);

    setDynamicCaptcha(newCaptcha);
  };

  const captchaBypassEmails = [
    "hpatel.extern@europ-assistance.in",
    "usaini.extern@europ-assistance.in",
    "eaitestingbp001@yopmail.com",
    "eaitestingbp002@yopmail.com",
    "eaitestingbp003@yopmail.com",
    "eaitestingbp004@yopmail.com",
    "housertp@yopmail.com",
    "housertp3@yopmail.com",
    "smusertp@yopmail.com",
    "tmusertp@yopmail.com",
    "smusertp2@yopmail.com",
    "eaiba006@yopmail.com",
  ];

  const onSubmit = async (data) => {
    const userInputCaptcha = data.manualCaptcha;
    const userEmail = data.email;
    const isCaptchaBypassed = captchaBypassEmails.includes(userEmail);
    // const dynamicCaptcha = userInputCaptcha; // for testing : remove in prod
    // if (userInputCaptcha === dynamicCaptcha) { //for production only 
  if (isCaptchaBypassed || userInputCaptcha === dynamicCaptcha) { //for UAT only 
      const userDetails = {
        email: data.email,
        password: data.password,
      };
      try {
        setLoading(true);
        dispatch(
          login(
            userDetails,
            navigate,
            remember,
            toast,
            setLoading,
            false, () => {}
          )
        );
      } catch (error) {
        console.log(error);
      }
    } else {
      setCaptchaError("Invalid captcha. Please try again.");
    }
  };


  const handleCaptchaChange = () => {
    setCaptchaError("");
  };


  const handleSSOLogin = async () => {
    try {
      setLoading(true);
      const response = await loginWithSAML();
      if (response.status === 200) {
        // Handle successful login
        toast.success("Login successful!");
        navigate("/user/role");
      } else {
        // Handle login failure
        toast.error("Login failed. Please try again.");
      }
    } catch (error) {
      console.error("SSO login error:", error);
      // toast.error("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

   const handleNewPasswordSubmit = () => {

    console.log("newPassword length : ",newPassword.length);
const passwordPolicyRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{12,}$/;

if (!passwordPolicyRegex.test(newPassword)) {
  setNewPasswordError(
    "New Password update failed. Password must be at least 12 characters long and include uppercase, lowercase, and a special character."
  );
  return;
}
    // if ((!newPassword.length >= 8) && (!newPassword.length <= 12)) {
    // if (newPassword.length < 12) {
    //   // setNewPasswordError("New password must be at least 8 and lesser than 12 characters.");
    //   setNewPasswordError("New Password update failed. Please ensure your password meets the required policy.");
    //   return;
    // }

    const originalData = formDataRef.current;
    const userDetails = {
      email: originalData.email,
      password: originalData.password,
      newPassword,
    };

    setShowPasswordModal(false);
    setNewPassword("");
    setNewPasswordError("");

    try {
      setLoading(true);
      dispatch(login(userDetails, navigate, remember, toast, setLoading, false, () => {}));
    } catch (error) {
      console.error(error);
    }
  };



  return (
    <Fragment>
      {localStorage.getItem("isRememberMe") == true && navigate("/rememberMe")}
      {/* <Header/> */}
      {/* <Container fluid={true} style={{ background: "blue", padding: "20px"}}> */}

      <Container fluid={true} style={{ background: "#f8f9fe"}}>
        <Row>
          <Col xl="12" className="p-0">
            <Row className="no-gutters">
              {/* <Col xl="7">
                <Row>
                  <Col xl="9" className="d-none d-lg-block">
                    <div className="b-center bg-size">
              <div>
              <img
                    className="for-light"
                    src={require("../assets/images/logo/eaitravelLogo.png")}
                    alt=""
                    style={{minHeight : "610px", width:'700px'}}
                    // style={{minHeight : "400px",width:'500px', padding: "0px", borderRadius: "20px", objectFit: "cover",  marginLeft: "40px",}}
                  />
              </div>
                    </div>
                  </Col>
                </Row>
              </Col> */}

          <Col xl="7" className="b-center bg-size" style={{ backgroundImage: `url(${require("../assets/images/logo/eaitravelLogo.png")})`,backgroundSize:"cover",backgroundPosition:"center",display:"block" }}>
            <img className="bg-img-cover bg-center" style={{display:"none"}} src={require("../assets/images/logo/eaitravelLogo.png")} alt="looginpage"/>
          </Col>
              

              <Col xl="5">
                <div className="login-card" >
                  {/* <div className="login-card login-extra-css" style={{ background: "#f8f9fe",minHeight : "400px", marginRight: "90px !important",  padding: "0px" }}> */}
                  <div>
                  <div>
                <a className="logo" href="#javascript" >
                  {/* <img className="img-fluid for-light" src={require("../assets/images/logo/login.png")} alt=""/> */}
                  {/* <img className="img-fluid for-dark" src={require("../assets/images/logo/logo_dark.png")} alt=""/> */}
                </a>
              </div>
                    <div className="login-main login-tab">
                      <form
                        className="theme-form"
                        onSubmit={handleSubmit(onSubmit)}
                      >
                        <h4>{t("login")}</h4>
                       
                        <p>{"Enter your email & password to login"}</p>
                        {/* <h5>Total Policy punch Today : {totalPolicy ?totalPolicy :'Syncing'} </h5> */}
                        <hr />
                        <FormGroup className="form-row">
                          <Label className="col-form-label">{t("email")}</Label>
                          <Input
                            className="form-control"
                            // id="email"
                            type="email"
                            name="email"
                            onChange={handleChange}
                            placeholder="Enter Email"
                            innerRef={register}
                          // invalid={errors.email?.message ? true : false}
                          />
                          {errors.email && (
                            <div className="error-message">
                              {errors.email.message}
                            </div>
                          )}
                        </FormGroup>
                        <FormGroup className="form-row">
                          <Label className="col-form-label">
                            {t("password")}
                          </Label>
                          <Input
                            className="form-control"
                            // id="password"
                            type={togglePassword ? "text" : "password"}
                            name="password"
                            innerRef={register}
                            onChange={handleChange}
                          // invalid={errors.password?.message  ? true : false}
                          />
                          <div
                            className="show-hide"
                            onClick={() => setTogglePassword(!togglePassword)}
                          >
                            <span
                              className={togglePassword ? "" : "show"}
                            ></span>
                          </div>
                          {errors.password && (
                            <div className="error-message">
                              {errors.password.message}
                            </div>
                          )}
                        </FormGroup>

                        <br />

                        <Row>
                          <Col xl="6" sm="12">
                            <FormGroup>
                              <Input
                                className="form-control"
                                type="text"
                                name="manualCaptcha"
                                innerRef={register}
                                placeholder="Enter captcha here"
                                onChange={handleCaptchaChange}
                              />
                            </FormGroup>
                          </Col>

                          <Col xl="4" sm="6">
                            <div
                              style={{
                                textAlign: "right",
                                fontWeight: "bold",
                                fontSize: "20px",
                                userSelect: "none",
                                cursor: "pointer",
                              }}
                            >
                              {dynamicCaptcha}
                            </div>
                          </Col>
                          <Col xl="2" sm="6">
                            <Button
                              color="primary"
                              size="sm"
                              className="btnCustom"
                              onClick={generateDynamicCaptcha}
                            >
                              <i className="fa fa-refresh"></i>
                            </Button>
                          </Col>
                        </Row>
                        {captchaError && (
                          <div className="error-message">{captchaError}</div>
                        )}

                        <br />

                        <FormGroup>
                          <div className="checkbox ml-3">
                            <input
                              id="checkbox1"
                              type="checkbox"
                              onClick={validateRemember}
                              ref={register}
                              name="rememberPassword"
                            />
                            <Label className="text-muted" htmlFor="checkbox1">
                              {t("remember_password")}
                            </Label>
                          </div>
                          <div className="link">
                            <Link
                              to={`${process.env.PUBLIC_URL}/forgot-password`}
                            >
                              {t("forgot_password")}
                            </Link>
                          </div>
                        </FormGroup>
                        {!isEAIUser && (
                      <>

                        <div className="form-group mb-0">
                          <Button
                            color="primary"
                            className="btn-block"
                            type="submit"
                            disabled={loading ? loading : loading}
                          >
                            {loading ? "PLEASE WAIT..." : t("sign_in")}
                          </Button>
                        </div>
                        </>
                    )}
                        <h6 className="text-muted mt-4 or">{"Or Sign in with"}</h6>
                          <div className="social mt-4">
                            <div className="btn-showcase">
                              <Button className="btn-block" color="light" onClick={handleSSOLogin}>
                                <img src={require("../assets/images/logo/Microsoft_Logo_128px.png")} width={25} alt="" srcSet="" /> EAI SSO
                              </Button>
                            </div>
                          </div>
                      </form>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
        {/* Modal for new password input */}
      <Modal isOpen={showPasswordModal} toggle={() => {
        setShowPasswordModal(false);
        setNewPassword("");
        setNewPasswordError("");
      }}>
        <ModalHeader toggle={() => {
          setShowPasswordModal(false);
          setNewPassword("");
          setNewPasswordError("");
        }}>
          Password Update
        </ModalHeader>
        <ModalBody>
          {/* <p>Your password is too short. Please enter a new password with at least 12 characters.</p> */}
          <p>Your password has expired. Kindly create a new password in accordance with the updated password policy</p>
          <p><strong>PASSWORD POLICY :-</strong>  (12 or above chars & Mininmum 1 upper, 1 lower, 1 number, 1 special char)</p>
          <FormGroup>
            <Label>New Password</Label>
            <Input
              type="password"
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value);
                setNewPasswordError("");
              }}
              placeholder="Enter new password"
            />
            {newPasswordError && <div className="error-message">{newPasswordError}</div>}
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleNewPasswordSubmit}>
            Submit New Password
          </Button>
        </ModalFooter>
      </Modal>
      {/* </Container> */}

      {/* <Container
        fluid={true}
        className="d-none d-lg-block"
        style={{ background: "#f8f9fe" }}
      >
        <Row>
          <Col xl="1"></Col>
          <Col xl="10">
            <WhomWeServe />
          </Col>
          <Col xl="1"></Col>
        </Row>
      </Container> */}
    </Fragment>
  );
};

export default Logins;
